// extracted by mini-css-extract-plugin
module.exports = {"item":"TestimonialRating_theme1_item__g6gvX","star":"TestimonialRating_theme1_star__HKXxj","star_wrapper":"TestimonialRating_theme1_star_wrapper__lvpqr"};